import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
//fontawesome
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ROUTE_AMLS_SMART_SCREENING } from '../../../../constants/globalConstants';

import styles from './index.scss';

export const TicketDetailTopPannel = ({ GS, navigateTo, data }) => {
  const getTicketDetailTopPanel = (GS) => {
    const sortedSettings = orderBy(
      GS.widgetConfig,
      ['columnIndex'],
      ['asc']
    ).filter((column) => column.columnVisibility);
    return sortedSettings.map((setting, key) => {
      return (
        <div className={styles.list} key={key}>
          {orderBy(setting.columnDetail, ['itemIndex'], ['asc'])
            .filter((column) => column.visibility)
            .map((column, idx) => {
              return (
                <React.Fragment key={idx}>
                  <div className={styles.list_head}>{column.itemLabel}</div>
                  <div className={styles.list_content}>
                    {data[column.itemName] ? data[column.itemName] : '--'}
                  </div>
                </React.Fragment>
              );
            })}
        </div>
      );
    });
  };

  if (GS?.isVisible)
    return (
      <div className={styles.wrapper}>
        <div className={styles.head} id="alertDetail-head">
          <div className={styles.alignCenter}>
            <div
              id="backarrowBtn"
              onClick={() =>
                navigateTo(`${ROUTE_AMLS_SMART_SCREENING}/tickets`)
              }
              style={{ cursor: 'pointer' }}>
              <FontAwesomeIcon icon={faArrowLeft} color={'#000'} />
            </div>
            <h4>Ticket Details</h4>
          </div>
        </div>
        <div className={styles.head_content}>{getTicketDetailTopPanel(GS)}</div>
      </div>
    );
  else return null;
};

TicketDetailTopPannel.propTypes = {
  GS: PropTypes.object.isRequired,
  navigateTo: PropTypes.func.isRequired,
  data: PropTypes.object.isRequired
};

export default TicketDetailTopPannel;
